import { defineComponent as _defineComponent } from 'vue'
import { MAX_SCREEN_WIDTH } from "@/const/options";

export default /*#__PURE__*/_defineComponent({
  __name: 'PageEmptyRouter',
  setup(__props) {


return { __sfc: true,MAX_SCREEN_WIDTH }
}

})